import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SubmitButton from '../Share/Button/SubmitButton';
import CancelButton from '../Share/Button/CancelButton';
import { connect } from 'react-redux';
import { Field, reduxForm } from "redux-form";
import { closeDialogKUF } from '../../actions/kUFAction';
import { EditIntegerNumberField, EditDatePickerField, EditSelectField, EditTextField, EditDecimalNumberField } from '../Share/EditComponents';
import ComponentInLine from '../Share/ComponentInLine';

class FormKUF extends React.Component {
    handleClose = () => {
        this.props.closeDialogKUF();
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.props.IsOpen}

                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent>
                        <form onSubmit={this.props.handleSubmit(this.props.onSubmit)}>

                            <div>
                                <Field
                                    name='partnerID'
                                    component={this.props.EditSelectField}
                                    label='Supplier'
                                    dataSource={this.props.partnersSelectBox}
                                >
                                </Field>
                            </div>
                            <ComponentInLine>
                                <div>
                                    <Field
                                        name='orderNumber'
                                        component={this.props.EditIntegerNumberField}
                                        label='OrderNumber'
                                    />
                                </div>
                                <div>
                                    <Field
                                        name='dateArrive'
                                        component={this.props.EditDatePickerField}
                                        label='DateArrive'
                                    />
                                </div>

                                <div>
                                    <Field
                                        name='date'
                                        component={this.props.EditDatePickerField}
                                        label='Date'
                                    />
                                </div>
                            </ComponentInLine>

                            <div>
                                <Field
                                    name='bankAccount'
                                    component={this.props.EditTextField}
                                    label='BankAccount'
                                />
                            </div>
                            <ComponentInLine>
                                <div>
                                    <Field
                                        name='amountExVAT'
                                        component={this.props.EditDecimalNumberField}
                                        label='AmountExVAT'
                                    />
                                </div>
                                <div>
                                    <Field
                                        name='vAT'
                                        component={this.props.EditDecimalNumberField}
                                        label='VAT'
                                    />
                                </div>
                                <div>
                                    <Field
                                        name='totalAmount'
                                        component={this.props.EditDecimalNumberField}
                                        label='TotalAmount'
                                    />
                                </div>
                            </ComponentInLine>
                            <ComponentInLine>
                                <div>
                                    <Field
                                        name='paymentDueDate'
                                        component={this.props.EditDatePickerField}
                                        label='PaymentDueDate'
                                    />
                                </div>
                                <div>
                                    <Field
                                        name='paymentDate'
                                        component={this.props.EditDatePickerField}
                                        label='PaymentDate'
                                    />
                                </div>
                            </ComponentInLine>

                            <div>
                                <Field
                                    name='description'
                                    component={this.props.EditTextField}
                                    label='Description'
                                />
                            </div>
                            <div>
                                <Field
                                    name='note'
                                    component={this.props.EditTextField}
                                    label='Note'
                                />
                            </div>
                            <DialogActions>
                                <CancelButton onClick={this.handleClose}></CancelButton>
                                <SubmitButton></SubmitButton>
                            </DialogActions>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}
const validate = (formValues) => {
    const errors = {};

    if (!formValues.orderNumber) {
        errors.orderNumber = 'Polje je obavezno!';
    }
    if (!formValues.partnerID) {
        errors.partnerID = 'Polje je obavezno!';
    }
    if (!formValues.bankAccount) {
        errors.bankAccount = 'Polje je obavezno!';
    }
    if (!formValues.amountExVAT) {
        errors.amountExVAT = 'Polje je obavezno!';
    }
    if (!formValues.vAT) {
        errors.vAT = 'Polje je obavezno!';
    }
    if (!formValues.totalAmount) {
        errors.totalAmount = 'Polje je obavezno!';
    }
    return errors;
}


const mapStateToProps = state => {
    return { partnersSelectBox: Object.values(state.partnersSelectBox), }
}
const formWrapper = reduxForm({
    form: 'formKUF',
    validate: validate,
    destroyOnUnmount: false,
    enableReinitialize: true
})(FormKUF);

export default connect(mapStateToProps, { closeDialogKUF, EditIntegerNumberField, EditDatePickerField, EditSelectField, EditTextField, EditDecimalNumberField })(formWrapper);